import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Minus, Plus } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { http, formatApiError } from "@/lib/api";
import { useBranding } from "@/context/BrandingContext";

const FALLBACK = [{ up_to: 50, label: "Validando dados" }, { up_to: 99, label: "Finalizando" }, { up_to: 100, label: "Resgate processado" }];

export const progressStage = (v, stages) => {
  const list = [...(stages?.length ? stages : FALLBACK)].sort((a, b) => a.up_to - b.up_to);
  return (list.find((s) => v <= s.up_to) || list[list.length - 1]).label;
};

export const ProgressBar = ({ value, testId, stages }) => {
  const { config } = useBranding();
  return (
  <div data-testid={testId}>
    <div className="mb-1.5 flex justify-between text-xs text-slate-400">
      <span className="animate-pulse text-slate-200" data-testid={`${testId}-stage`}>{progressStage(value, stages || config?.progress_stages)}…</span>
      <span className="font-mono-x text-slate-100" data-testid={`${testId}-value`}>{value}%</span>
    </div>
    <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10">
      <div className="h-full rounded-full transition-[width] duration-700 ease-out" style={{ width: `${value}%`, background: "var(--brand)" }} />
    </div>
  </div>
  );
};

export const RedeemProgressControl = ({ req, onChanged }) => {
  const current = req.redeem_progress || 0;
  const [value, setValue] = useState(current);
  useEffect(() => setValue(current), [current]);

  const save = async (v) => {
    const p = Math.max(0, Math.min(100, v));
    setValue(p);
    try {
      await http.post(`/admin/requests/${req.id}/redeem/progress`, { progress: p });
      onChanged();
    } catch (e) { toast.error(formatApiError(e)); setValue(current); }
  };

  return (
    <div className="mb-4 space-y-3 rounded-sm border border-white/10 bg-black/20 p-3" data-testid="redeem-progress-control">
      <ProgressBar value={value} testId="admin-redeem-progress" />
      <Slider value={[value]} max={100} step={5} onValueChange={([v]) => setValue(v)} onValueCommit={([v]) => save(v)} data-testid="redeem-progress-slider" />
      <div className="flex flex-wrap gap-2">
        <button onClick={() => save(value - 10)} className="btn-ghost-sm" data-testid="redeem-progress-minus"><Minus className="h-3.5 w-3.5" /> 10%</button>
        <button onClick={() => save(value + 10)} className="btn-ghost-sm" data-testid="redeem-progress-plus10"><Plus className="h-3.5 w-3.5" /> 10%</button>
        <button onClick={() => save(value + 25)} className="btn-ghost-sm" data-testid="redeem-progress-plus25"><Plus className="h-3.5 w-3.5" /> 25%</button>
        <button onClick={() => save(100)} className="btn-ghost-sm" data-testid="redeem-progress-100">100%</button>
      </div>
    </div>
  );
};
